module.exports = __webpack_public_path__ + "img/10-avatar male.b1f6a2c2.png";